import { capitalize } from 'lodash'

import { reservationData } from 'constants/e2eClasses'
import PAYMENT_METHODS from 'constants/paymentMethods'
import PHONE_TYPES from 'constants/phoneTypes'
import SSR_TYPES from 'constants/ssrTypes'
import { buildCountryAreaCode } from 'containers/checkout/passengers-step/form/helpers'
import { isEmpty } from 'helpers/utils'

// Return Document Types Options
export const getIdOptions = documentTypes =>
  documentTypes &&
  documentTypes.map(item => ({
    value: item.code,
    label: item.name
  }))

// Return Country Options
export const getCountryOptions = countries =>
  countries.map(item => ({
    value: item.code,
    label: item.name
  }))

// Return Airlines Options
export const getAirlineOptions = airlines =>
  airlines.map(item => ({
    value: item.iataCode,
    label: item.name
  }))

// Return Special Foods Options
export const getSpecialMealsOptions = specialFoods => {
  const specialMeal =
    specialFoods &&
    specialFoods.ssrTypes &&
    specialFoods.ssrTypes.find(({ type }) => type === SSR_TYPES.MEAL)

  if (specialMeal && specialMeal.availableSSRs) {
    return specialMeal.availableSSRs.map(({ code, name }) => ({
      value: code,
      label: name
    }))
  }

  return []
}

// Return Special Services Options
export const getSpecialServicesOptions = specialServices => {
  const specialRequest =
    specialServices &&
    specialServices.ssrTypes &&
    specialServices.ssrTypes.find(({ type }) => type === SSR_TYPES.SPECIAL_REQUEST)

  if (specialRequest && specialRequest.availableSSRs) {
    return specialRequest.availableSSRs.map(({ code, name }) => ({
      value: code,
      label: name
    }))
  }

  return []
}

// Return Country Area Code Options

export const getCountryAreaCodeOptions = countries =>
  countries.map(item => ({
    value: item.code,
    label: `${item.name} (${item.areaCode})`
  }))

export const getArplusCountryAreaCodeOptions = countries =>
  countries.map(item => ({
    value: item.areaCode,
    label: `${item.name} (${item.areaCode})`
  }))

// Return Country Area Code With IsoCode Options
export const getCountryAreaCodeWithIsoCodeOptions = countries =>
  countries.map(item => ({
    value: buildCountryAreaCode(item.code, item.areaCode),
    label: `${item.name} (${item.areaCode})`
  }))

export const getAreaCodeWithIsoCodeOptions = countries =>
  countries.map(item => ({
    value: item.areaCode,
    label: `${item.name} (${item.areaCode})`
  }))

const months = [
  'label.months-0',
  'label.months-1',
  'label.months-2',
  'label.months-3',
  'label.months-4',
  'label.months-5',
  'label.months-6',
  'label.months-7',
  'label.months-8',
  'label.months-9',
  'label.months-10',
  'label.months-11'
]

export const getTranslatedDropdownMonths = callback =>
  months.map((key, index) => ({ value: index + 1, label: capitalize(callback(key)) }))

// Phone Type Options
export const getPhoneTypeOptions = (value, translation) => [
  {
    value: PHONE_TYPES.LAND_LINE,
    text: translation('label.house'),
    e2eClass: reservationData.home,
    selected: value === PHONE_TYPES.LAND_LINE
  },
  {
    value: PHONE_TYPES.MOBILE,
    text: translation('label.cellphone'),
    e2eClass: reservationData.mobile,
    selected: value === PHONE_TYPES.MOBILE
  }
]

// Days Options
export const getDaysOptions = () =>
  [...Array(31)].map((_, index) => ({
    value: index + 1,
    label: index + 1
  }))

// Days Options
export const getYearsOptions = (typeValidation, lastDate) => {
  let max = lastDate.getFullYear() + 1
  let min = max - 100

  if (typeValidation) {
    if (typeValidation.MIN_AGE) {
      max = lastDate.getFullYear() - typeValidation.MIN_AGE + 1
    }
    if (typeValidation.MAX_AGE) {
      min = lastDate.getFullYear() - typeValidation.MAX_AGE
    }
  }

  let arrayYears = []
  for (let i = min; i < max; i++) {
    arrayYears.push({
      value: i,
      label: i
    })
  }

  return arrayYears.sort((a, b) => b.value - a.value)
}

export const getYearsOptionsExpire = documentType => {
  const maxYearLapse = (documentType && documentType.expirationThreshold) || 15
  const max = new Date().getFullYear() + maxYearLapse
  const min = new Date().getFullYear()

  const arrayYears = []
  for (let i = min; i <= max; i++) {
    arrayYears.push({
      value: i,
      label: i
    })
  }
  return arrayYears
}

export const getProvincesOptionsByCountry = (provinces, country) =>
  (provinces || [])
    .filter(province => province.country === country)
    .map(({ name, code }) => ({
      value: code,
      label: name
    }))

export const getCreditCardOptions = (
  paymentMethodSelection = {},
  paymentOptions = {},
  isSecondForm
) => {
  if (isEmpty(paymentMethodSelection) || isEmpty(paymentOptions)) {
    return []
  }

  const { paymentValidations } = paymentMethodSelection

  const { selectedType, selectedPaymentMethod, selectedIssuer, selectedInstallment } = !isSecondForm
    ? paymentMethodSelection
    : paymentMethodSelection.secondCardPaymentMethod

  if (selectedType === PAYMENT_METHODS.INTEREST_FREE_INSTALLMENTS) {
    const { interestFreeInstallments } = paymentOptions

    const optionsSelectedInstallments = (interestFreeInstallments[selectedInstallment] || [])
      .filter(({ issuer, paymentMethod }) =>
        selectedIssuer ? issuer === selectedIssuer : paymentMethod === selectedPaymentMethod
      )
      .map(({ paymentMethod }) => paymentMethod)

    const filteredPaymentMethods = (paymentValidations || []).filter(payment =>
      optionsSelectedInstallments.includes(payment.code)
    )

    return (filteredPaymentMethods || []).map(({ code, name }) => ({
      value: code,
      label: name
    }))
  }

  return paymentValidations
    .filter(({ code }) => code === selectedPaymentMethod)
    .map(({ code, name }) => ({
      value: code,
      label: name
    }))
}
